import { render, staticRenderFns } from "./orderExport.vue?vue&type=template&id=0b4b5a4e&scoped=true&"
import script from "./orderExport.vue?vue&type=script&lang=js&"
export * from "./orderExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4b5a4e",
  null
  
)

export default component.exports